import { Flex, Link, Module, Text, useModal } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { CREATE_CONTACT_PERSON_MODAL_ID } from '../ContactPersonModal'

export const ContactPersonsEmptyState = (): ReactElement => {
  const { t } = useTranslation()
  const { open: openCreateModal } = useModal(CREATE_CONTACT_PERSON_MODAL_ID)

  return (
    <Module>
      <Module.Section>
        <Flex justifyContent="center">
          <Text>
            {t('contact.detail.contact_persons.empty_state_text')}{' '}
            <Link onClick={openCreateModal}>{t('contact.detail.contact_persons.empty_state_link')}</Link>
          </Text>
        </Flex>
      </Module.Section>
    </Module>
  )
}
